import { useState } from "react";
import MomSysShipDialog from "../dialogTypes/MomSysShipDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function MomSysShipButton(props) {
    const { id, grid, refresh, schema, createButtonName, onSuccess, customizeErrorMsgCallback, ...others } = props;
    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onShipSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <MomSysShipDialog
                id={id + "ship-dialog"}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onShipSuccess}
            />
        </>
    );
}

export default MomSysShipButton;
